export const CURRENT = 'current';
export const REGISTERED = 'registered';
export const PRELIMINARY = 'preliminary';
export const FINAL = 'final';
export const CANCELLED = 'cancelled';
